module.exports = __webpack_public_path__ + "img/background-home-min.2a813bb6.jpg";